import React from 'react';
import styles from './ContactInformations.module.sass';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import PhoneInput from '../../../components/PhoneInput';
import Icon from '../../../components/Icon';
import cn from 'classnames';

const ContactInformations = ({ partner, onPartnerChange, onDropdownChange, loading }) => {
    return (
        <Card className={styles.card} title="Informations de contact" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Email de contact"
                    name="contact_email"
                    type="email"
                    placeholder="contact@example.com"
                    value={partner?.contact_email || ''}
                    onChange={onPartnerChange}
                />
                <PhoneInput
                    className={styles.field}
                    label="Téléphone de contact"
                    name="contact_phone"
                    id="contact_phone"
                    placeholder="+33 6 XX XX XX XX"
                    value={partner?.contact_phone || ''}
                    onChange={onPartnerChange}
                    autoComplete="tel"
                />
                
                <div className={styles.field}>
                    <div className={styles.label}>LinkedIn</div>
                    <div className={styles.fieldInput}>
                        <Icon name="link" size="24" />
                        <input
                            className={styles.input}
                            type="url"
                            name="linkedin"
                            value={partner?.linkedin || ''}
                            onChange={onPartnerChange}
                            placeholder="URL LinkedIn"
                        />
                    </div>
                </div>

                <div className={styles.field}>
                    <div className={styles.label}>Facebook</div>
                    <div className={styles.fieldInput}>
                        <Icon name="link" size="24" />
                        <input
                            className={styles.input}
                            type="url"
                            name="facebook"
                            value={partner?.facebook || ''}
                            onChange={onPartnerChange}
                            placeholder="URL Facebook"
                        />
                    </div>
                </div>
                
                <div className={styles.field}>
                    <div className={styles.label}>Site web</div>
                    <div className={styles.fieldInput}>
                        <Icon name="link" size="24" />
                        <input
                            className={styles.input}
                            type="url"
                            name="website"
                            value={partner?.website || ''}
                            onChange={onPartnerChange}
                            placeholder="URL du site web"
                        />
                    </div>
                </div>
            </div>

            <div className={styles.divider}></div>
 
            <div className={styles.submitContainer}>
              <button
                className={cn("button", styles.submit)}
                type="submit"
                disabled={loading}
              >
                {loading ? "Création en cours..." : "Créer le partenaire"}
              </button>
            </div>
        </Card>
    );
};

export default ContactInformations;